/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_WorkingInputs */

const en_loading_working = /** @type {(inputs: Loading_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working…`)
};

const id_loading_working = /** @type {(inputs: Loading_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memproses…`)
};

/**
* | output |
* | --- |
* | "Working…" |
*
* @param {Loading_WorkingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_working = /** @type {((inputs?: Loading_WorkingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_WorkingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_working(inputs)
	return en_loading_working(inputs)
});